<template>
	<div class="secServiceAd" :class="!isMobile ? 'pcbox' : ''">
		<div class="serviceCon" :style="{width: isMobile ? '100%' :'50%'}">
			<div class="pcHomeTitle" :class="{'m': isMobile}"><img src="~@/assets/images/common/service_titlel.png"></div>
			<div class="serviceBox" :class="{'m': isMobile}">
				<div class="serviceTitle">
					<div class="titleItem">{{ $t('home.serviceTime') }}</div>
					<div class="titleItem">{{ $t('home.serviceGame') }}</div>
					<div class="titleItem">{{ $t('home.serviceList') }}</div>
				</div>
				<div class="serviceList">
					<ul>
						<li v-for="(item,index) in serverList" :key="index">
							<span class="timeItem">{{ parseTime(item.openTime,'{m}-{d} {h}:{i}') }}</span>
							<span class="gameItem">{{ item.gameName }}<i class="hot" v-if="index < 3"></i></span>
							<span class="servieItem">{{ item.serviceName }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="adCon" :style="{width: isMobile ? '100%' :'50%'}">
			<div class="pcHomeTitle" :class="{'m': isMobile}"><img src="~@/assets/images/common/service_titler.png"></div>
			<div class="adBox" :class="{'m': isMobile}">
				<div class="isRecharge">
					{{ $t('home.serviceTotal') }}：{{ userRecharge.total }}
					<a class="btn" v-if="userRecharge.isGet == 1">{{ $t('common.isgetbtn') }}</a>
					<a class="btn" v-else-if="userRecharge.isGet == -1">{{ $t('home.notStandard') }}</a>
					<a class="btn active" @click="handleGetCoin" v-else>{{ $t('common.getbtn') }}</a>
				</div>
				<div class="serviceBox gmbox" :class="{'m': isMobile}">
					<div class="serviceTitle">
						<div class="titleItem">{{ $t('home.serviceMoney') }}</div>
						<div class="titleItem">{{ $t('home.serviceCoin') }}</div>
						<div class="titleItem">{{ $t('home.serviceBtn') }}</div>
					</div>
					<div class="serviceList">
						<ul>
							<li v-for="(item,index) in rankList" :key="index">
								<p class="moneyItem">{{ item.targetAmount }}</p>
								<p class="coinItem">{{ item.platCoinNum }}</p>
								<p class="btnItem">
									<span v-if="item.status == 1">{{ $t('home.isStandard') }}</span>
									<span v-else-if="item.status == -1">{{ $t('home.notStandard') }}</span>
									<!-- <a class="btn active" @click="handleGetCoin">{{ $t('common.getbtn') }}</a> -->
									<!-- <a class="btn" v-else>{{ $t('common.isgetbtn') }}</a> -->
								</p>
							</li>
						</ul>
					</div>
				</div>
				
				<div class="useRuleMid" @click="showRankRules = !showRankRules">
					<van-icon name="question-o" style="margin-right: 0.3125rem;" />{{ $t('home.rankRules') }}</div>
				
			</div>
		</div>
		<!-- 充值活动规则 -->
		<van-popup v-model:show="showRankRules" round teleport="body" >
			<div class="guidesBox">
				<div class="divide">
					<div class="titletxt">
						<p class="title">{{ $t('home.rankRules') }}</p>
					</div>
				</div>
				<div style="max-height: 70vh;overflow-y: scroll;">
					<div class="rulesCon">
						<p>{{ $t('home.rankRule1') }}</p>
						<p>{{ $t('home.rankRule2') }}</p>
						<p>{{ $t('home.rankRule3') }}</p>
						<p>{{ $t('home.rankRule4') }}</p>
						<p>{{ $t('home.rankRule5') }}</p>
						<p>{{ $t('home.rankRule6') }}</p>
						<p>{{ $t('home.rankRule7') }}</p>
					</div>
					
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,reactive,watch,computed } from 'vue'
	import useConfigStore from '@/store/modules/config'
	import useUserStore from '@/store/modules/user'
	import { getServerList, getRechargeRanks, getMyRecharge, getRechargeAward } from "@/api/index";
	
	const { proxy } = getCurrentInstance();
	
	const deferredPrompt = ref(null);
	const serverList = ref([])
	const rankList = ref([])
	const total  = ref(0)
	const queryParams = reactive({
		pageNum: 1,
		pageSize: 10
	})
	const showRankRules = ref(false)
	const isMobile = computed(() => {
		return useConfigStore().isMobile
	})
	const userRecharge = computed(() => {
		return useUserStore().userRecharge || 0
	})
	onMounted(() => {
		getServerList(queryParams).then((response) => {
			serverList.value = response.rows
			total.value = response.total
		})
		
		getRechargeRanks().then((res) => {
			rankList.value = res.data
		})
	})
	const getUserRecharge = () => {
		getMyRecharge().then((res) => {
			useUserStore().setUserRecharge(res.data)
		})
	}
	const handleGetCoin = () => {
		// proxy.$toast('아직 이벤트 시간이 되지 않았습니다. 8월 1일부터 수령 가능합니다.')
		getRechargeAward().then((res) => {
			proxy.$dialog({
			  message: `${res.msg}`,
			}).then(() => {
			  getUserRecharge()
			});
		})
	}
</script>

<style lang="less" scoped>
	.adBox{
		width: 100%;background: linear-gradient(to bottom,transparent,#fff);padding: 0.75rem 0 0;
		position: relative;
		.useRuleMid{
			position: absolute;right: 1.5rem;bottom: -0.25rem;font-size: 0.8125rem;cursor: pointer;z-index: 111;
		}
		.isRecharge{
			position: absolute;right: 1.25rem;top: 0.1875rem;display: flex;align-items: center;
			.btn{
				margin-left: 10px;
			}
		}
		&.m{
			padding-top: 0;background: #EAF0F3;
			.useRuleMid{
				bottom: -0.5rem;right: 0.75rem;
			}
			.isRecharge{
				right: 0.75rem;top: -2rem;
			}
		}
		
	}
	.secServiceAd{
		background: #EAF0F3;
		padding-bottom: 1.25rem;height: calc(100vh - 90px);
		.pcHomeTitle{
			margin-top: 40px;height: 82px;padding-left: 0;
			img{
				height: 100%;
			}
			&.m{
				margin-top: 00;height: 42px;padding-left: 0.625rem;padding-top: 0.625rem;
			}
			
		}
		&.pcbox{
			display: flex;align-items: center;justify-content: center;
			background: transparent;padding-bottom: 0;height: auto;
			.serviceCon{
				width: 33%;height: 418px;overflow: hidden;
				padding-left: 20px;padding-right: 10px;box-sizing: border-box;
				
			}
			.adCon{
				flex: 1;
				height: 418px;
			}
			.adBox{
				background: transparent;padding: 42px 20px 3px 10px;box-sizing: border-box;
				display: flex;align-items: center;height: 340px;position: relative;
				margin-top: -40px;
				.serviceBox{
					// width: calc(50% - 0.75rem);margin-right: 1.125rem;
					width: 100%;
					height: 100%;
				}
				
			}
		}
	}
	.secServiceAd{
		.btn{
			width: 65px;height: 26px;display: inline-block;line-height: 26px;
			background: url('~@/assets/images/common/getgm_btnbg1.png') no-repeat;
			background-size: 100%;cursor: pointer;text-align: center;
			font-size: 12px;color: #fff;font-weight: bold;
			&.active{
				background: url('~@/assets/images/common/getgm_btnbg.png') no-repeat;
				background-size: 100%;
			}
		}
		.serviceBox{
			width: 100%;height: calc(100% - 125px);
			// border: 1px solid #ccc;background: #fff;border-radius: 5px;
			background: url('~@/assets/images/common/service_bg1.png') no-repeat;
			background-size: 100%;
			padding: 12px 15px 15px;box-sizing: border-box;
			&.gmbox{
				background: url('~@/assets/images/common/service_bg2.png') no-repeat;
				background-size: 100%;
			}
			&.m{
				height: 14rem;padding: 12px 15px;
				.serviceTitle{
					height: 1.2rem;
				}
				.serviceList{
					height: calc(100% - 1.2rem);padding: 4px;
					ul{
						li{
							font-size: 0.75rem;line-height: 20px;padding: 1px 0;
							.btnItem{
								.btn{
									width: 56px;height: 18px;line-height: 18px;
								}
							}
						}
					}
				}
			}
			.serviceTitle{
				width: 100%;height: 34px;
				// background: url('~@/assets/images/common/service_titlebg.png') no-repeat;
				// background-size: 100%;
				color: #fff;
				display: flex;align-items: center;justify-content: center;
				.titleItem{
					width: 53%;font-size: 14px;text-align: center;font-weight: 500;
					&:first-child{
						width: 22%;padding-left: 5px;
					}
					&:last-child{
						width: 25%;padding-right: 5px;
					}
				}
			}
			.serviceList{
				width: 100%;height: calc(100% - 36px);overflow: hidden;
				padding: 4px 10px;box-sizing: border-box;
				ul{
					margin: 0;padding: 0;width: 100%;height: 100%;
					overflow-y: scroll;
					li{
						font-size: 14px;padding: 3px 0;line-height: 26px;
						display: flex;align-items: center;justify-content: center;
						span{
							display: inline-block;
						}
						.timeItem{
							width: 22%;flex-shrink: 0;color: #737373;
						}
						.btnItem{
							width: 25%;flex-shrink: 0;color: #737373;text-align: center;
							
						}
						.moneyItem{
							width: 22%;color: #0e0d0d;text-align: center;flex-shrink: 0;
						}
						.coinItem{
							width: 100%;overflow: hidden;
							color: #f44f77;text-align: center;
						}
						.gameItem{
							width: 100%;color: #0e0d0d;padding-left: 5px;
							.hot{
								display: inline-block;width: 32px;height: 10px;
								background: url('~@/assets/images/common/icon_hot.png') no-repeat;
								background-size: cover;margin-left: 2px;
							}
						}
						.servieItem{
							width: 25%;flex-shrink: 0;overflow: hidden;margin-left: 12px;
							color: #f44f77;
						}
					}
					li + li{
						border-top: 1px dashed #818789;
					}
				}
			}
		}
		
	}
</style>